var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"hamburger-wrap",on:{"click":_vm.toggleClick}},[_c('svg-icon',{class:[!_vm.isActive && 'is-active', 'hamburger'],attrs:{"icon-class":"collapse"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }